import {environment} from '@environments/environment';

export class ApiUtil {

  public static buildUrl(
    apiPrefix: string,
    urlSuffix: string = '',
    queryParams: {[param: string]: string | boolean | number;} = {}
  ): string {
    const url = new URL(`${environment.apiUrl}/${apiPrefix}${urlSuffix}`);
    for (const [key, val] of Object.entries(queryParams)) {
      url.searchParams.set(key, String(val));
    }
    return url.toString();
  }

}
